import Vue from 'vue'
import Tool from '../script/tool.js'
import { INDICE_DEFAULT } from '../pageview/web/constants.js'

const state = {
  compared: false,
  comparedEnd: "",
  compareStart: "",
  tableIndices: []
}

const mutations = {
  SET_COMPARED(state, comparedObj) {
    Vue.set(state, 'compared', comparedObj.compared)
    Vue.set(state, 'compareStart', comparedObj.compStart)
    Vue.set(state, 'compareEnd', comparedObj.compEnd)
  },
  SET_TABLE_INDICES(state, indices) {
    Vue.set(state, 'tableIndices', indices)
  }
}

const actions = {
  SET_COMPARED({ state, commit, rootState }, comparedObj) {
    commit('SET_COMPARED', comparedObj)
  },
  SET_TABLE_INDICES({ state, commit, rootState }, indices) {
    commit('SET_TABLE_INDICES', indices)
  }
}

const getters = {
  indicesMenu: (state, getters) => {
    let indices = [
      {value: "_", label:"请选择指标"}
    ]
    _.map(state.tableIndices, (item) => {
      indices.push({value: item, label: Tool.getIndexName(item)})
    })
    return indices.length > 1 ? indices : INDICE_DEFAULT.map(arr => ({ value: arr[0], label: arr[1]}));
  },
  uiError: (state, getters, rootState) => {
    return rootState.uiError
  },
  fetchLineChartabled: (state, getters, rootState) => {
    return rootState.tableCheckList.length == 0 || !rootState.drawChartabled
  },
  twoIndiceSelectabled: (state, getters, rootState) => {
    return rootState.tableCheckList.length > 1
  },
  domainId: (state, getters, rootState) => {
    return rootState.domainId
  },
  start: (state, getters, rootState) => {
    return rootState.start.replace(/-/g, '/')
  },
  end: (state, getters, rootState) => {
    return rootState.end.replace(/-/g, '/')

  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/webmodule.js